export * from './patient-demographic-info.component';
